import { makeStyles } from '@material-ui/core/styles'
import Text from 'core/elements/Text'
import Theme from 'core/themes/model'
import React from 'react'
import clsx from 'clsx'

const useStyles = makeStyles<Theme>((theme) => ({
  content: {
    display: 'grid',
    gap: 16,
    gridAutoRows: 'max-content',
  },
  contentContainer: {
    display: 'flex',
    alignItems: 'center',
    gap: 16,
    marginBottom: theme.spacing(2),
  },
  iconWrapper: {
    display: 'flex',
    height: '32px',
    width: '32px',
    borderRadius: '50%',
    justifyContent: 'center',
    alignItems: 'center',
  },
}))

export default function ModalFormHeaders({
  imagePath,
  message,
  className,
}: {
  imagePath: string
  message: string | React.ReactNode
  className?: string
}) {
  const classes = useStyles()

  return (
    <div className={clsx(classes.contentContainer, className)}>
      <img
        className={classes.iconWrapper}
        alt="Load Balancer"
        src={imagePath}
        data-testid="create-load-balancer-modal--img-0"
      />
      <div className={classes.content}>
        <Text variant="body2">{message}</Text>
      </div>
    </div>
  )
}
